import script from "./working-hours.vue?vue&type=script&setup=true&lang=js"
export * from "./working-hours.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__